export default "__VITE_ASSET__BWu3jXYK__"